/**
 * Validation utilities
 *
 * Common utilities for validation schema creation and error handling.
 */
import i18n from "../utils/i18n";
/**
 * Gets a localized validation error message
 *
 * This function dynamically fetches the translation for the provided key
 * using the current language setting in i18n.
 */
export const t = (key, defaultMessage) => {
    // Get the translation directly rather than returning a function
    const translation = i18n.t(`validation.${key}`);
    return translation === `validation.${key}`
        ? defaultMessage || key
        : translation;
};
/**
 * Creates a validator function that uses the current locale
 *
 * This ensures that validation error messages are always in the currently
 * selected language, even when the language changes after initial validation.
 */
export const createValidator = (schemaFactory) => {
    return (value) => {
        const schema = schemaFactory();
        const result = schema.safeParse(value);
        // If validation succeeded, there's no error message
        if (result.success) {
            return { isValid: true, errorMessage: null };
        }
        // For errors, evaluate the error message function to get the current
        // translation based on the active language
        const errorObj = result.error.errors[0];
        const errorMessage = errorObj?.message;
        // No need to check for function type anymore since t() now returns a string directly
        return {
            isValid: false,
            errorMessage: errorMessage || null,
        };
    };
};
